// Decorative pack of stroked rings drawn from "Circle Pattern 1.svg".
// Rendered inline so we can control colour/opacity and avoid external load.
// Used as a subtle motif on dark sections.

const COLS = 8;
const ROWS = 6;
const STEP_X = 128.72;
const STEP_Y = 120.34;
const R = 56.48;
const STROKE = 6;

// Row palette — top → bottom, mirrors the supplied asset
const ROW_COLORS = [
  "#983519", // Rustic Terracotta
  "#E5E9DD", // Tranquil Sage
  "#FFD682", // Golden Sand
  "#F4B369", // Inviting Amber
  "#F65900", // Sunset Orange
  "#F65900",
];

function buildCircles() {
  const out = [];
  for (let r = 0; r < ROWS; r++) {
    const offset = r % 2 === 1 ? STEP_X / 2 : 0;
    for (let c = 0; c < COLS; c++) {
      const cx = 60.48 + offset + c * STEP_X;
      const cy = 60.48 + r * STEP_Y;
      out.push(
        <circle
          key={`${r}-${c}`}
          cx={cx}
          cy={cy}
          r={R}
          fill="none"
          stroke={ROW_COLORS[r]}
          strokeWidth={STROKE}
        />
      );
    }
  }
  return out;
}

export default function CirclePattern({ className = "", opacity = 0.35 }) {
  return (
    <svg
      viewBox="0 0 1078.51 826"
      preserveAspectRatio="xMidYMid slice"
      className={className}
      style={{ opacity }}
      aria-hidden="true"
    >
      {buildCircles()}
    </svg>
  );
}
